import React from 'react';
import cs from 'classnames';
import css from './index.css';
import {track} from '~/misc/metrics';


class TipPop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: false,
    };
    this.showTip = this.showTip.bind(this);
    this.closeTip = this.closeTip.bind(this);
  }

  render() {
    const popClassName = `${this.props.direction}TipPop`;
    const arrowClassName = `${this.props.direction}Arrow`;

    const children = (
      <div className={cs(css.tipPop, css[popClassName])}>
        <div className={css.contentWrap}>
          <div className={css.qestion}>{this.props.QDocument}</div>
          <div className={css.answer}>{this.props.ADocument}</div>
          <div className={css.btn} onClick={this.closeTip}>OK</div>
        </div>
        <div className={cs(css.arrow, css[arrowClassName])}/>
      </div>);

    return (
      <div className={css.wrap}>
        <div className={cs(css.icon, this.state.flag && css.blueIcon)} onClick={this.showTip}>
          ?
        </div>
        <div>{ this.state.flag && children }</div>
      </div>);
  }

  closeTip(e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      flag: false,
    });
  }

  showTip(e) {
    e.preventDefault();
    e.stopPropagation();
    track('rate check in load details', {
      'What is rate check icon': 1,
    });
    let bool = this.state.flag;
    this.setState({flag: !bool});
  }
}

export default TipPop;




// WEBPACK FOOTER //
// ./src/components/common/TipPop/index.js